import { AnchorHTMLAttributes } from 'react';

export type IDropdownMenuItemProps = AnchorHTMLAttributes<HTMLAnchorElement>;

const DropdownMenuItem = ({ children }: IDropdownMenuItemProps) => <div className="dropdown-menu__item">{children}</div>;

export default DropdownMenuItem;
